const TripPlanningFaqs = {
  heading: 'Trip planning & customization',
  faqs: [
    {
      question: 'How do I get an instant itinerary?',
      answer:
        'We first ask you a few questions to get to know your travel style and any other trip requirements, then we create an itinerary tailored around your preferences!',
    },
    {
      question: 'Can I make changes to the itinerary?',
      answer:
        "Every part of your itinerary is customizable—activities, accommodations, pace, and destination. You can add, remove, or swap anything to make it your own. There's no fee to customize, and if a change affects the price, you'll see it update instantly.",
    },
    {
      question: 'How do I calculate the final cost of my trip when I make changes to my itinerary?',
      answer:
        "As you make changes to your itinerary—like swapping activities or adjusting accommodations—you'll see your estimated total cost update instantly. Our local expert will confirm hotel availability and prices. No surprises, no guesswork, just full transparency as you plan.",
    },
  ],
}

export const WellnessRetreatFaqs = [
  TripPlanningFaqs,
  {
    heading: 'Pricing & payments',
    faqs: [
      {
        question: "I'm not sure how much to price the retreat?",
        answer: 'We will be able to give you pricing suggestions based on our experience from 500+ tours.',
      },
      {
        question: 'Why is this price more expensive than the hotel website?',
        answer:
          "On the hotel website, the price is different because the prices for trips vary from standard tourism rates, and they don't include meals, activities, or transfers. Additionally, website costs do not account for your complimentary trip.",
      },
      {
        question: 'Can you please send me a breakdown of the prices?',
        answer:
          'The prices from our local partners are inclusive of all associated costs such as airport transfers, activity transfers, meals, and accommodation. To offer the lowest net rates, we are unable to provide a breakdown of prices.',
      },
      {
        question: 'What are the payment plans for clients?',
        answer:
          "We offer flexible payment plans for your community to book with us. They can opt for 0% interest monthly installment plan, deposit + 1-time payment plan or full upfront payment.<br/><br/>Monthly installments will depend on the time left between the date they book (first installment) and the final payment day (according to the local operator's policies).",
      },
      {
        question: 'How do I get paid?',
        answer:
          "The TourHero's payment will be paid out in two installments: 50% will be paid 2 weeks before the trip and 50% will be paid 2 weeks after the trip is over. We will send a contract a month before the trip departs and the payment is done through a platform named Deel. From Deel, you can transfer the money to your bank account.",
      },
    ],
  },
  {
    heading: 'Booking & guest management',
    faqs: [
      {
        question: 'How does the retreat host see how many bookings they have?',
        answer:
          "You'll receive an email notification with your bookings. You can also access your <a href='/'>TourHero.com</a> account and see your participants' information.",
      },
      {
        question: 'What happens to the deposit if a participant cancels the spot?',
        answer:
          'The deposit is non-refundable, as we need it to pay the operators to block off the rooms and other services, therefore it will remain in the platform.',
      },
      {
        question: "What if I don't sell the minimum number of guest spots?",
        answer:
          'The minimum number of guests to get the complimentary trip is 6 unless otherwise stated by your Inspiration Expert. If the minimum is not met, we are still able to run the retreat with fewer guests, but your trip cost will be out of pocket. If the minimum number is not reached and you decide not to run the retreat, your guests will be notified 60 days before departure and will receive a refund for their payments.',
      },
    ],
  },
  {
    heading: 'Logistics, policies & contracts',
    faqs: [
      {
        question: "Are the retreat host's flights included?",
        answer:
          "The retreat host's flights are not included. Make sure to consider this when deciding on the price per person.",
      },
      {
        question: 'How do I travel for free?',
        answer:
          'If you bring six people to travel with you on a trip, you get to travel for free, with all accommodations, activities, transportation, and food included (excluding flights and add-ons). <em>Please note, the requirement of six people is subject to change.</em>',
      },
      {
        question: 'Is there a service contract?',
        answer:
          'We have a contract that states your offering, pricing, minimum number of participants, retreat date, and the deadline to have the bookings on the platform. This service contract is mutually beneficial.',
      },
      {
        question: 'What is the cancellation policy?',
        answer:
          'You can find the cancellation policies on the itinerary page under “Cancellation policy”.<br/><br/>The cancellation policies are usually around 60 to 90 days before departure—by this time, we must have all the bookings in the platform to confirm the trip.',
      },
    ],
  },
]

export const CreatorFaqs = structuredClone(WellnessRetreatFaqs)
CreatorFaqs[1].faqs[0].question = "I'm not sure how much to price the trip?"
CreatorFaqs[2].faqs[0].question = 'How does the creator see how many bookings they have?'
CreatorFaqs[2].faqs[2].answer =
  'The minimum number of guests to get the complimentary trip is 6 unless otherwise stated by your Inspiration Expert. If the minimum is not met, we are still able to run the trip with fewer guests, but your trip cost will be out of pocket. If the minimum number is not reached and you decide not to run the trip, your guests will be notified 60 days before departure and will receive a refund for their payments.'
CreatorFaqs[3].faqs[2].answer =
  'We have a contract that states your offering, pricing, minimum number of participants, trip date, and the deadline to have the bookings on the platform. This service contract is mutually beneficial.'
CreatorFaqs[3].faqs[0].question = "Are the creator's flights included?"
CreatorFaqs[3].faqs[0].answer =
  "The creator's flights are not included. Make sure to consider this when deciding on the price per person."

export const MbaFaqs = [
  TripPlanningFaqs,
  {
    heading: 'Pricing & payments',
    faqs: [
      {
        question: 'What are the payment plans available?',
        answer:
          'We offer flexible payment plans for your friends to book with us. They can opt for 0% interest monthly installment plan, deposit + 1-time payment plan or full upfront payment.',
      },
      {
        question: 'Is there a fee to plan with TourHero?',
        answer: "Planning with us is completely free, you won't need to pay anything upfront to organize your trip.",
      },
    ],
  },
  {
    heading: 'Logistics & policies',
    faqs: [
      {
        question: 'How do I coordinate the travel logistics?',
        answer:
          'We provide full logistics service when you work with us such as payment collection, roommate preference coordination, accommodating dietary restriction, automated spot transfer and more. Chat with us to learn more.',
      },
      {
        question: 'What if the group size changes?',
        answer:
          'We will provide the best price for the requested group size. If there is a change in group size, we will do our very best to keep the price change to the minimal. In the event that we are not able to, we will be upfront with the minimum group size commitment prior to launching the trip.',
      },
      {
        question: 'What is the refund policy?',
        answer:
          'Our refund policy varies depending on the trip. Do check the cancellation policy on the booking page for the most accurate policy. In general, we provide refund when cancelling prior to the due date which ranges between 45 - 60 days prior to trip departure. Full refund is also available when the spot is transferred to another person.',
      },
    ],
  },
]
